import tools from '@/sui/data/sheets/edit/tools'
import catheter from '@/sui/data/sheets/edit/catheter'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'

const selColIlcBlc = tools.allTrue(
  catheter.select.kt,
  tools.inList(fields.isColIlcBlc, [1, 2, 3, 4])
)

const blc = tools.allTrue(
  catheter.select.kt,
  tools.equals(fields.isColIlcBlc, 4)
)

const ktm = {
  v1: tools.allTrue(blc, tools.match(fields.catheterType, /^C[24]$/)),
  v2: tools.allTrue(blc, tools.match(fields.catheterType, /^C[248]$/))
}

const select = {
  urinary: tools.equals(fields.urinary, 1),
  colIlcBlc: selColIlcBlc,
  colIlcBlcC1C2C4: tools.allTrue(
    selColIlcBlc,
    tools.match(fields.catheterType, /^C[124]$/)
  ),
  colIlcBlcC1C2C4C8: tools.allTrue(
    selColIlcBlc,
    tools.match(fields.catheterType, /^C[1248]$/)
  ),
  blc,
  dd5: tools.allTrue(blc, tools.equals(fields.divDiag, 5)),
  ktm: {
    v1: ktm.v1,
    v2: ktm.v2
  },
  ktm7: {
    v1: tools.allTrue(ktm.v1, tools.equals(fields.previousManip, 1)),
    v2: tools.allTrue(ktm.v2, tools.equals(fields.previousManip, 1))
  }
}

const urinaryStart = tools.cfg.date(
  fields.urinaryStart, 'du sondage urinaire', {
    sel: select.urinary,
    op: true
  }
)

const urinaryEnd = tools.cfg.date(
  fields.urinaryEnd, 'de fin du sondage urinaire',
  { sel: select.urinary, op: true }
)

const colIlcBlc = tools.cfg.date(
  fields.colIlcBlc, 'de COL / ILC / BLC', { sel: select.colIlcBlc }
)

const urinary = tools.cfg.list(
  fields.urinary, 'Sondage urinaire', go.fields.yesNoUnknown
)

const catheterType = (function () {
  function build (f) {
    return tools.cfg.list(
      fields.catheterType, 'Type de cathéter', f
    )
  }

  return {
    v1: build(go.fields2019.reaInfCatheterType),
    v2: build(go.fields2024.reaInfCatheterType),
    v3: build(go.fields.reaInfCatheterType)
  }
})()

const catheterInsertion = (function () {
  function build (f) {
    return tools.cfg.list(
      fields.insertionSite, 'Site de pose', f
    )
  }

  return {
    v1: build(go.fields2019.reaInsertion),
    v2: build(go.fields2021.reaInsertion),
    v3: build(go.fields.reaInsertion)
  }
})()

const isColIlcBlc = tools.cfg.list(
  fields.isColIlcBlc, 'COL / ILC / BLC', go.fields.reaColIlcBlc, {
    sel: catheter.select.kt, ph: 'Taper le code ou le nom...'
  }
)

export default {
  select,
  urinaryStart,
  urinaryEnd,
  colIlcBlc,
  urinary,
  catheterType,
  catheterInsertion,
  isColIlcBlc
}
